import {KernelComponent} from '@roomle/web-sdk/lib/definitions/typings/kernel';

export class UiCallbacks {
  public onSelectionChange = (_selectionMode: string, _isRoot: boolean, _hasChildren: boolean, _components: KernelComponent[]): any => undefined;
  public onSelectionCancel = (): any => undefined;
}
